import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { CAT_CONCEPT_CASH_BOX_ENDPOINT } from '../../../../../../../utility/SourceAPI'


// Obtener todos los conceptos de caja
export const getConcepts = createAsyncThunk('concepts/getConcepts', async () => {
    const response = await axios.get(CAT_CONCEPT_CASH_BOX_ENDPOINT)
    return {
        data: response.data
    }
})

// Agregar un nuevo concepto de caja
export const addConcept = createAsyncThunk('concepts/addConcept', async (concept, { dispatch }) => {
    const response = await axios.post(CAT_CONCEPT_CASH_BOX_ENDPOINT, concept)
    await dispatch(getConcepts()) // Actualizar la lista después de agregar
    return response.data
})

// Actualizar un concepto de caja
export const updateConcept = createAsyncThunk('concepts/updateConcept', async (concept, { dispatch }) => {
    const response = await axios.put(CAT_CONCEPT_CASH_BOX_ENDPOINT.concat(`${concept.id}/`), concept)
    await dispatch(getConcepts()) // Actualizar la lista después de editar
    return response.data
})

// Eliminar un concepto de caja
export const deleteConcept = createAsyncThunk('concepts/deleteConcept', async (id, { dispatch }) => {
    const response = await axios.put(CAT_CONCEPT_CASH_BOX_ENDPOINT.concat(`activate_deactivate/${id}`))
    await dispatch(getConcepts()) // Actualizar la lista después de eliminar
    return response.data
})

// Slice para manejar el estado de los conceptos de caja
export const conceptsSlice = createSlice({
    name: 'concepts',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getConcepts.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default conceptsSlice.reducer